<template>
	<main>
		<div class="wrapper-form">
			<CardForm :card-title="getString('welcome_back')" :card-body="getString('enter_detail_info')" :cta-text="getString('login_cta')" cta-exists>
				<div>
					<div>
						<AppTextInput type="email" ref="email" :value="getPrefillEmail()" :label="getString('email')" :placeholder="getString('email')" @pressed-enter="pressedEnterEmail" />
					</div>
					<div class="mt-20">
						<AppTextInput type="password" ref="password" :label="getString('password')" :placeholder="getString('password')" @pressed-enter="submitLogin" />
					</div>
					<div class="mt-20 otp-container" @click="otpCollapsed = !otpCollapsed">
						<div class="otp-explain">
							<p>{{ getString('do_you_have_2fa_enabled') }}</p>
							<AppChevronIcon :direction="otpCollapsed ? 'down' : 'up'" />
						</div>
						<AppDropdown :collapsed="otpCollapsed">
							<AppTextInput type="text" ref="otp" :label="getString('otp_code')" :placeholder="getString('otp_code')" @pressed-enter="submitLogin" @click.stop />
						</AppDropdown>
					</div>
					<div class="mt-20">
						<AppButton @click="submitLogin" :text="getString('login_cta')" :loading="loadingLogin" />
					</div>
				</div>
				<div class="links-list mt-30" v-if="!isIOS()">
					<p class="mb-5">{{ getString('not_registered_question') }} <span @click.stop="clickSignup"><a :href="linkSignup">{{ getString('signup_here') }}</a></span></p>
					<p><a :href="linkForgotPassword">{{ getString('forgot_password') }}</a></p>
				</div>
			</CardForm>
			<div class="environment-container" v-if="isNative">
				<div class="select-container">
					<AppSelect ref="select-environment" :values="optionsEnvironment" :selected-index="selectedEnvironmentIndex" :label="languageStore.getString('environment')" @selected="changeEnvironment" />
				</div>
				<div class="select-container">
					<AppSelect ref="select-domain" :values="optionsDomain" :selected-index="selectedDomainIndex" :label="languageStore.getString('domain')" @selected="changeDomain" />
				</div>
			</div>
		</div>
	</main>
	<AppNotification ref="invalid-email" :title="getString('error')" :body-text="getString('invalid_email')" :type="-2" />
	<AppNotification ref="password-too-short" :title="getString('error')" :body-text="getString('password_too_short')" :type="-2" />
	<AppNotification ref="error-generic" :title="getString('error')" :body-text="getString('error_generic')" :type="-2" />
	<AppNotification ref="wrong-credentials-info" :title="getString('error')" :body-text="getString('wrong_credentials_info')" :type="-2" />
	<AppNotification ref="wrong-otp" :title="getString('error')" :body-text="getString('wrong_otp')" :type="-2" />
	<AppNotification ref="mail-verification" :title="getString('error')" :body-text="getString('mail_verification_error')" :type="-2" />
	<BannerCookie
		bottom
		base-color="29edc0"
	/>
</template>

<script>
import {useLanguageStore} from "@/shared/stores";
import langObject from "@/console-login/assets/json/langs.json";
import langObjectAuto from "@/console-login/assets/json/auto.json";
import API from "@/shared/helpers/API";
import AppTextInput from "@/shared/components/AppTextInput.vue";
import AppButton from "@/shared/components/AppButton.vue";
import CardForm from "@/console-reset/components/CardForm.vue";
import AppNotification from "@/shared/components/AppNotification.vue";
import {validateEmail} from "@/shared/helpers/strings";
import AppDropdown from "@/shared/components/AppDropdown.vue";
import AppChevronIcon from "@/shared/components/AppChevronIcon.vue";
import AppSelect from "@/shared/components/AppSelect.vue";
import Hash from "@/shared/helpers/Hash";
import {getNative, isIOS, isNative} from "@/shared/helpers/webapp";
import {useNativeStore} from "@/console-new/stores";
import BannerCookie from "@/new-menu/components/modals/BannerCookie.vue";
import {setParam} from "@/shared/helpers/events";

export default {
	components: {BannerCookie, AppSelect, AppChevronIcon, AppDropdown, AppButton, AppTextInput, CardForm, AppNotification},
	setup() {
		const languageStore = useLanguageStore();
		return {languageStore, getString: languageStore.getString};
	},
	name: "App",
	data() {
		return {
			loadingLogin: false,
			otpCollapsed: true,
			optionsEnvironment: ["Alpha", "Beta", "Test", "Live"],
		}
	},
	computed: {
		isNative() {
			return isNative();
		},
		selectedEnvironmentIndex() {
			if(HOST === "qromoalpha.it") {
				return 0;
			} else if(HOST === "qromobeta.it") {
				return 1;
			} else if(HOST === "qromotest.it") {
				return 2;
			} else if(HOST === "qromo.it") {
				return 3;
			} else {
				return null;
			}
		},
		redirectUrl() {
			let url = redirectUrlParam;
			if(url) {
				url = url.replace("https://", "");
				url = url.replace("http://", "");
				url = url.replace("www.", "");
				let urlParts = url.split("/");
				if(urlParts.length > 1) {
					url = urlParts[0];
					if(url === HOST) {
						return redirectUrlParam;
					}
				}
			}
			return URL_HTML + "/console/new/";
		},
		linkForgotPassword() {
			return URL_HTML + "/console/reset-password/";
		},
		linkSignup() {
			return URL_HTML+'/console/signup/';
		},
		optionsDomain() {
			return Object.values(COUNTRIES).map(country => country.host);
		},
		selectedDomainIndex() {
			return Object.values(COUNTRIES).findIndex(country => country.host === HOST);
		}
	},
	methods: {
		isIOS() {
			return isIOS();
		},
		changeEnvironment() {
			getNative().setEnvironment(this.$refs["select-environment"].currentIndex, true)
		},
		changeDomain() {
			let protocol = (location?.protocol || "https:") + "//";
			window.location.href = protocol+Object.values(COUNTRIES)[this.$refs["select-domain"].currentIndex].host + "/console/login/";
		},
		getPrefillEmail() {
			if(prefillEmail) {
				return prefillEmail;
			} else {
				return "";
			}
		},
		pressedEnterEmail(value) {
			if(this.$refs && this.$refs['password'] && validateEmail(value)) {
				this.$refs['password'].focus()
			}
		},
		submitLogin() {
			let email = this.$refs.email.currentValue;
			if(validateEmail(email)) {

				let password = this.$refs['password'].currentValue;

				if(password.length > 7) {

					let otp = this.$refs['otp'].currentValue;

					this.loadingLogin = true;
					API.init().loginUser(email, password, otp, (response) => {
						if("access_token" in response) {
							localStorage.setItem("refresh_token", response.refresh_token);
							sessionStorage.setItem("oauth_token", response.access_token);

							const redirectUrl = this.redirectUrl;
							if(typeof iOSNative !== 'undefined' && window.webkit) {
								window.webkit.messageHandlers.tokenHandler.postMessage(response.refresh_token);
							} else {
								if (!window.location.href.includes(redirectUrl)) {
									window.location.replace(redirectUrl);
								}
							}

						} else {
							this.loadingLogin = false;
							if(response.error === "invalid_grant") {
								this.$refs["wrong-credentials-info"].openNotification();
							} else if(response.error === "2fa_required") {
								this.$refs["wrong-otp"].openNotification();
								this.otpCollapsed = false;
								setTimeout(() => {
									this.$refs["otp"].focus();
								}, 100);
							} else {
								this.$refs["error-generic"].openNotification();
							}
						}
					});

				} else {
					this.$refs["password-too-short"].openNotification();
				}

			} else {
				this.$refs["invalid-email"].openNotification();
			}
		},
		verifyCode(code, toUpdate) {
			this.loadingLogin = true;

			API.init().verifyCode(code, toUpdate, (response) => {
				if(response && response.result === "OK") {

					sessionStorage.setItem("oauth_token", response.oauth_token);
					localStorage.setItem("refresh_token", response.refresh_token);

					// Mark as new signup only for actual signups (not password resets)
					if(!toUpdate) {
						sessionStorage.setItem("new_signup", "1");
					}

					setTimeout(() => {
						if(typeof os !== 'undefined' && !!os && os === "ios") {
							window.location.replace("/console/ios/signup/?token="+response.refresh_token);
						} else {
							window.location.replace(this.redirectUrl);
						}
					}, 500);

				} else {
					this.loadingLogin = false;
					this.$refs["mail-verification"].openNotification();
				}
			});

		},
		loginRefreshToken(refreshToken) {

			this.loadingLogin = true;
			API.init().loginUserRefreshToken(refreshToken, (response) => {
				if("access_token" in response) {
					sessionStorage.setItem("oauth_token", response.access_token);

					const redirectUrl = this.redirectUrl;
					if (!window.location.href.includes(redirectUrl)) {
						window.location.replace(redirectUrl);
					}
				} else {
					localStorage.removeItem("refresh_token");
					this.loadingLogin = false;
				}
			});

		},
		clickSignup() {

			window.location.href = URL_HTML+"/console/signup/";

		}
	},
	created() {
		this.languageStore.addStrings(langObject, "login", langObjectAuto);
		API.init(URL_HTML, URL_HTML+"/console/login/");

		document.addEventListener('dblclick', function(event) {
			event.preventDefault();
		}, { passive: false });
	},
	mounted() {
		if(!!code) {
			this.verifyCode(code, toUpdate);
		} else {
			let refreshToken = localStorage.getItem("refresh_token");
			if(refreshToken) {
				this.loginRefreshToken(refreshToken);
			}
		}
	}
}
</script>

<style lang="scss">
.grecaptcha-badge {
	display: none;
}
</style>
<style lang="scss" scoped>
main {
	background-color: #f9fafd;
	.wrapper-form {
		min-height: 100vh;
		padding: 40px 20px 80px;
		position: relative;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		@media(max-width: 300px) {
			padding: 12px;
		}
		.links-list {
			p {
				font-size: 14px;
			}
			span {
				font-size: 14px;
			}
		}
	}
	.otp-container {
		background-color: #E5EDF6;
		padding: 12px;
		border-radius: 13px;
		cursor: pointer;
		max-width: 450px;

		.otp-explain {
			display: flex;
			justify-content: space-between;
			align-items: center;
			gap: 10px;

			p {
				font-size: 14px;
				color: #4F5A65;
				margin: 0;
			}
		}

		.input-wrapper {
			width: 100%;
			max-width: 160px;
		}
	}
	.environment-container {
		width: 100%;
		height: 100%;
		max-width: 960px;
		display: flex;
		flex-direction: column;
		background: #F9FAFD 0% 0% no-repeat padding-box;
		box-shadow: 0px 0px 45px rgba(37, 82, 157, 0.3019607843);
		border-radius: 39px;
		padding: 30px;
		margin-top: 40px;
		gap: 20px;

	}
}
</style>